<template>
  <v-card>
    <!-- Navigation par onglets -->
    <v-tabs
      v-model="tab"
      background-color="pink lighten-2"
      dark
      grow
      icons-and-text
    >
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#stats-global">
        Stats globales
        <v-icon>fas fa-chart-bar</v-icon>
      </v-tab>

      <v-tab href="#stats-users">
        Stats utilisateurs
        <v-icon>fas fa-users</v-icon>
      </v-tab>
    </v-tabs>

    <!-- Données des onglets -->
    <v-tabs-items v-model="tab">
      <!-- 
      *************************************
        Statistiques globales 
      *************************************
      -->
      <v-tab-item value="stats-global">
        <v-card class="ma-2" flat>
          <v-card-title class="pl-10 pt-10 justify-end" style="width: 100%">
            <export-btn entity="admin_stats" />
          </v-card-title>
          <!-- Squelette -->
          <v-row
            v-if="loading.globalStats"
            dense
            align="center"
            justify="start"
            class="pa-10"
          >
            <v-col
              v-for="i in [1, 2, 3, 4, 5, 6]"
              :key="i"
              class="my-3 col-md-3 col-sm-4 col-xs-6"
            >
              <v-skeleton-loader
                v-bind="attrs"
                type="list-item-avatar-two-line"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
          <!-- Carte de statistiques -->
          <v-row
            v-if="!loading.globalStats"
            dense
            align="center"
            justify="start"
            class="pa-10"
          >
            <v-col
              v-for="(item, i) in adminStatsData"
              :key="i"
              class="my-3 col-md-3 col-sm-4 col-xs-6"
            >
              <v-card :color="item.color">
                <div class="d-flex flex-no-wrap justify-space-between py-4 px-5">
                  <div>
                    <h5 class="title-truncate">{{ item.description }}</h5>
                    <p>{{ item.value }}</p>
                  </div>

                  <v-avatar tile>
                    <v-icon>
                      {{ item.icon }}
                    </v-icon>
                  </v-avatar>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-tab-item>
      <!-- 
      *************************************
        Statistiques utilisateurs 
      *************************************
      -->
      <v-tab-item value="stats-users">
        <v-card class="ma-2" flat>
          <v-card-title class="pl-10 pt-10" style="width: 100%">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Rechercher sur les noms"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>

            <export-btn entity="users" />
          </v-card-title>
          <!-- Squelette -->
          <v-skeleton-loader
            v-if="loading.userStats"
            type="table"
            :types="{
              table: 'table-thead, table-tbody, table-tfoot',
              'table-tbody': 'table-row-divider@12',
            }"
            min-width="100%"
          />
          <!-- Tableau -->
          <v-data-table
            :hidden="loading.userStats"
            :headers="headers"
            :items="users"
            :search="search"
          />
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>
<script>
//import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Api from "@/core/services/api.service";
import moment from "moment";
import ExportBtn from "@/components/admin/exportBtn";

export default {
  name: "adminKPI",
  components: { ExportBtn },
  data() {
    return {
      loading: {
        globalStats: true,
        userStats: true,
      },
      search: "",
      tab: null,
      headers: [
        { text: "Nom", value: "lastname", align: "start" },
        { text: "Prénom", value: "firstname", align: "start" },
        { text: "E-mail", value: "email", align: "start" },
        { text: "Client", value: "client.name", align: "start" },
        { text: "Nb connexions", value: "nbConnection", align: "start" },
        {
          text: "Parcour(s) démarré(s)",
          value: "nbCourseStarted",
          align: "start",
        },
        {
          text: "Parcour(s) complété(s)",
          value: "nbCourseCompleted",
          align: "start",
        },
        { text: "Crée le", value: "createdAt", align: "start" },
      ],
      adminStatsData: [],
      users: [],
      dialog: false,
    };
  },
  filters: {
    moment: function (date) {
      return moment.parseZone(date).format("DD/MM/YYYY");
    },
  },
  methods: {
    downloadCSV(rows, csvName) {
      let csvContent =
        "data:text/csv;charset=utf-8," +
        rows.map((e) => e.join(",")).join("\n");
      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", csvName);
      document.body.appendChild(link);
      link.click();
    },
    getAdminStats() {
      this.loading.globalStats = true;
      Api.query("admin_stats").then((adminStats) => {
        this.adminStatsData = adminStats.data["hydra:member"];
        this.loading.globalStats = false;
      });
    },
    getAllUsers() {
      this.loading.userStats = true;
      let params = { pagination: false };
      Api.query("users", { params }).then((users) => {
        this.users = users.data["hydra:member"];
        this.loading.userStats = false;
      });
    },
  },
  mounted() {
    this.getAdminStats();
    this.getAllUsers();
  },
};
</script>
